import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import "./AuthForm.scss";
import Error from "./Error";

import { connect } from "react-redux";
import { signInWithCreds } from "../../store/actions/AuthActions";

const schema = yup.object().shape({
  email: yup
    .string()
    .email("Debe ser un email válido")
    .required("Campo requerido"),
  password: yup
    .string()
    .min(6, "La contraseña debe ser de al menos 6 caracteres"),
});

const SignInForm = ({ signIn }) => {
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
  });

  return (
    <div className="w-full max-w-sm mx-auto my-8">
      <form
        onSubmit={handleSubmit(signIn)}
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
      >
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
            Email
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name="email"
            defaultValue=""
            ref={register}
            placeholder="Correo electrónico"
          />
          <Error error={errors.email}left></Error>
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="password"
          >
            Contraseña
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="password"
            name="password"
            defaultValue=""
            ref={register}
            placeholder="Contraseña"
          ></input>
          <Error error={errors.password}left></Error>
        </div>
        <div className="flex items-center justify-between flex-wrap">
          <button
            className="w-full bg-brand-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="submit"
          >
            Iniciar sesión
          </button>
        </div>
      </form>

      <p className="text-center text-gray-500 text-xs">
        &copy;2020 Super Cerca. Todos los derechos reservados.
      </p>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signInWithCreds(creds)),
  };
};

export default connect(null, mapDispatchToProps)(SignInForm);
